module.exports = __webpack_public_path__ + "img/chr_ts_11.8bd15b7a.png";